const LinkIconSVG = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4297 13C10.8591 13.5741 11.407 14.0491 12.0362 14.3929C12.6654 14.7367 13.3612 14.9411 14.0763 14.9923C14.7915 15.0435 15.5093 14.9403 16.181 14.6897C16.8528 14.4392 17.4628 14.047 17.9697 13.54L20.9697 10.54C21.8805 9.59695 22.3845 8.33394 22.3731 7.02296C22.3617 5.71198 21.8358 4.45791 20.9088 3.53087C19.9817 2.60383 18.7277 2.07799 17.4167 2.0666C16.1057 2.0552 14.8427 2.55918 13.8997 3.46997L12.1797 5.17997"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4299 11.0002C14.0004 10.4261 13.4525 9.95104 12.8233 9.60729C12.1941 9.26353 11.4984 9.05911 10.7832 9.00789C10.0681 8.95667 9.3503 9.05986 8.67854 9.31044C8.00678 9.56103 7.39677 9.95316 6.88989 10.4602L3.88989 13.4602C2.9791 14.4032 2.47513 15.6662 2.48652 16.9772C2.49791 18.2882 3.02375 19.5423 3.95079 20.4693C4.87784 21.3964 6.1319 21.9222 7.44288 21.9336C8.75387 21.945 10.0169 21.441 10.9599 20.5302L12.6699 18.8202"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinkIconSVG;
